export default [
	{
		id: "points",
		name: "resources.contests.fields.type.points",
	},
	{
		id: "ranking",
		name: "resources.contests.fields.type.ranking",
	},
];
